import {EnvironmentProviders, Provider} from '@angular/core';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {
    MSAL_GUARD_CONFIG,
    MSAL_INSTANCE,
    MSAL_INTERCEPTOR_CONFIG,
    MsalBroadcastService,
    MsalGuard,
    MsalGuardConfiguration,
    MsalInterceptor,
    MsalInterceptorConfiguration,
    MsalService
} from '@azure/msal-angular';
import {STATIC_CONFIGS} from '../../configs/static.config';
import {ProtectedResourceScopes} from '@azure/msal-angular';
import {msalInstanceFactory} from '../factories/msal-instance.factory';

export const MSAL_PROVIDERS: Array<Provider | EnvironmentProviders> = [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true
    },
    {
        provide: MSAL_INSTANCE,
        useFactory: msalInstanceFactory,
    },
    {
        provide: MSAL_GUARD_CONFIG,
        useValue: {
            interactionType: STATIC_CONFIGS.msal.interactionType,
            loginFailedRoute: STATIC_CONFIGS.msal.redirectUri,
            authRequest: {
                scopes: STATIC_CONFIGS.msal.scopes
            }
        } as MsalGuardConfiguration
    },
    {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useValue: {
            interactionType: STATIC_CONFIGS.msal.interactionType,
            protectedResourceMap: new Map<string, Array<string | ProtectedResourceScopes> | null>(STATIC_CONFIGS.msal.protectedResourceMap)
        } as MsalInterceptorConfiguration
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
];
